export default class Hideable {
	constructor(element, hiddenOnStart = false, duration = 300) {
		this.element = element;
		this.duration = duration;

		if (!hiddenOnStart) this.show();
		else this.hide();
	}

	show() {
		this.element.style.display = 'block';

		// Cancel the race condition for a smooth animation
		setTimeout(() => {
			this.element.style.opacity = '1';
		}, 0);
	}

	hide() {
		this.element.style.opacity = '0';

		setTimeout(() => {
			this.element.style.display = 'none';
		}, this.duration);
	}

	toggle(show) {
		if(show)
			this.show();
		else this.hide();
	}
}